<template>
  <div
   
    :class="computedRootClasses"
  >
    <!-- Absolute overlays should NOT contain contents, as the overlay will intercept all pointer events. -->
    <slot v-if="!isAbsolutePositioned" />

    <div
      v-show="show"
      :class="computedOverlayClasses"
    >
      <AtomSpinner v-if="show" />
      <span v-if="message">{{ message }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { OverlayPosition, OverlayVariant } from './types'

const props = withDefaults(defineProps<{
  show?: boolean
  position?: OverlayPosition
  variant?: OverlayVariant
  message?: string
  rounded?: boolean | 'bottom' | 'top'
  blur?: boolean
}>(), {
  variant: 'default',
  position: 'relative',
})

const isAbsolutePositioned = computed(() => props.position === 'absolute')
const isFixedPositioned = computed(() => props.position === 'fixed')

const computedRootClasses = computed(() => ([
  {
    'absolute inset-0 pointer-events-none': isAbsolutePositioned.value,
    'relative': !isAbsolutePositioned.value,
  },
]))

const computedOverlayClasses = computed(() => ([
  'inset-0 flex flex-col gap-1 items-center justify-center text-sm z-50 pointer-events-auto',
  {
    fixed: isFixedPositioned.value,
    absolute: !isFixedPositioned.value,
  },
  {
    'bg-transparent': props.variant === 'clear',
    'bg-white': props.variant === 'opaque',
    'bg-white/75': props.variant === 'default',
  },
  {
    'rounded-b-xl': props.rounded === 'bottom',
    'rounded-t-xl': props.rounded === 'top',
    'rounded-xl': props.rounded === true,
  },
  {
    'backdrop-blur-xs': props.blur,
  },
]))
</script>
